if(document.querySelector('.plyr__progress')) {
    document.querySelector('.plyr__progress input').setAttribute("tabindex", "-1")
}